import { z } from "zod";

export const SOCIAL_POST_LAYOUT_RECIPE_IDS = [
  "full_bleed_lower_third",
  "full_bleed_side_plaque",
  "split_editorial",
  "poster_lockup",
  "magazine_caption_overlay",
  "image_stack_story",
  "quote_card_photo",
  "product_detail_callout",
  "announcement_strip",
  "minimal_logo_signature",
] as const;

export type SocialPostLayoutRecipeId = (typeof SOCIAL_POST_LAYOUT_RECIPE_IDS)[number];

export const socialPostLayoutRecipeIdSchema = z.enum(SOCIAL_POST_LAYOUT_RECIPE_IDS);

export const SOCIAL_POST_RECIPE_VISUAL_TONES = [
  "editorial",
  "premium",
  "playful",
  "urgent",
  "technical",
] as const;

export type SocialPostRecipeVisualTone = (typeof SOCIAL_POST_RECIPE_VISUAL_TONES)[number];

export const socialPostRecipeVisualToneSchema = z.enum(SOCIAL_POST_RECIPE_VISUAL_TONES);
